export default {
  en: {
    section: {
      booking: 'Booking',
      marketplace: 'Marketplace',
      internal: 'Forum',
    },
    publish_details: {
      by_user: 'by',
      in_community: 'in',
      in_group: 'in group',
      by_community: 'by',
      by_group: 'by group',
    },
  },
};
